import type { Variation } from '@gonfalon/openapi/types';
import { stringifyValue, type StringifyValueOptions } from '@gonfalon/types/stringifyValue';

export function getFlagVariationDisplayValue(variation: Variation, options?: StringifyValueOptions) {
  if (!!variation.name) {
    return variation.name;
  }

  return stringifyValue(variation.value, options);
}
